<apc-action-card [hideCardCss]="isCreate">
    <img *ngIf="!isCreate" icon src="assets/ico/orders.svg" alt="user" /><span *ngIf="!isCreate" title>{{'order.details'
        | translate}}</span>
    <apc-mono-action-buttons *ngIf="!isCreate" (editEvent)="editFormEvent($event)" [edit]="editForm"
        (saveEvent)="saveForm()" (cancelEvent)="cancelForm()" [deleteItem]="true" [form]="form"
        (preDeleteEvent)="preDeleteOrder()" [disableDeleteConfirmButton]="disableDeleteConfirmButton"
        [isQuestion]="isQuestion" (deleteEvent)="deleteOrder()" [deleteText]="deleteOrderText" buttons>
    </apc-mono-action-buttons>
    <div content class="fullwidth pl-3 pr-4" [class.editForm]="editForm">
        <form [formGroup]="form" *ngIf="form">

            <div *ngIf="isCreate">
                <div class="container-fluid">
                    <div class="row">
                        <div class="container-fluid my-2">
                            <div class="row">
                                <div class="form-group col-lg-6">
                                    <label>{{'order.name' | translate}} *</label>
                                    <apc-form-input [class]="'form-control'" [disabled]="false" formControlName="name"
                                        [type]="'text'">
                                    </apc-form-input>
                                </div>
                                <div class="form-group col-lg-6">
                                    <label>{{'order.customer' | translate}} *</label>
                                    <apc-form-select formControlName="customer" [items]="customer"
                                        (isOpen)="fetchCustomer()" [loading]="customerLoading" [isObject]="true">
                                    </apc-form-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- CRM DATA -->
            <div *ngIf="!isCreate">
                <div class="container-fluid">
                    <div class="row">
                        <div class="apc-form-card">
                            <span class="title">{{'order.order' | translate}}</span>
                            <div class="container-fluid my-2">
                                <div class="row">

                                    <div class="form-group col-lg">
                                        <label>{{'order.source' | translate}}</label>
                                        <apc-form-input [class]="'form-control autogenerated'" [disabled]="false"
                                            formControlName="source" [type]="'text'">
                                        </apc-form-input>
                                    </div>
                                    <div class="form-group col-lg">
                                        <label>{{'order.code' | translate}}</label>
                                        <apc-form-input [class]="'form-control autogenerated'" [disabled]="false"
                                            formControlName="code" [type]="'text'">
                                        </apc-form-input>
                                        <input class="form-control" type="text" formControlName="identifier" hidden />
                                    </div>
                                    <div class="form-group col-lg">
                                        <label>{{'order.createdAt' | translate}}</label>
                                        <apc-form-input [class]="'form-control autogenerated'" [disabled]="true"
                                            formControlName="createdAt" [type]="'text'">
                                        </apc-form-input>
                                    </div>
                                    <div class="form-group col-lg">
                                        <label>{{'order.modifiedAt' | translate}}</label>
                                        <apc-form-input [class]="'form-control autogenerated'" [disabled]="true"
                                            formControlName="modifiedAt" [type]="'text'">
                                        </apc-form-input>
                                    </div>
                                </div>
                                <div class="row my-4">
                                    <div class="form-group col-lg-8">
                                        <label>{{'order.name' | translate}} *</label>
                                        <apc-form-input [class]="'form-control'" [disabled]="false"
                                            formControlName="name" [type]="'text'">
                                        </apc-form-input>
                                    </div>
                                    <div class="form-group col-lg">
                                        <label>{{'order.link' | translate}}</label>
                                        <a *ngIf="data.link" [href]="data.link" target="_blank" class="url-icon">
                                            <div class="icon fill-blue" aria-label="link"
                                                [inlineSVG]="'assets/ico/external-link-solid.svg'"></div>
                                        </a>
                                        <apc-form-input [class]="'form-control'" [disabled]="false"
                                            formControlName="link" [type]="'text'">
                                        </apc-form-input>
                                    </div>
                                </div>
                                <div class="row my-4">
                                    <div class="form-group col-lg-4">
                                        <label>{{'order.customer' | translate}} *</label>
                                        <a *ngIf="data.customer && data.customer.identifier"
                                            [href]="'/customer/' + data.customer.identifier" class="url-icon"
                                            style="left: 92px !important;">
                                            <div class="icon fill-blue" aria-label="link"
                                                [inlineSVG]="'assets/ico/link-blue.svg'"></div>
                                        </a>
                                        <apc-form-select formControlName="customer" [items]="customer"
                                            (isOpen)="fetchCustomer()" [loading]="customerLoading" [isObject]="true"
                                            [optionDescription]="['code']">
                                        </apc-form-select>
                                    </div>

                                    <div class="form-group col-lg-4">
                                        <label>{{'order.opportunity' | translate}}</label>
                                        <apc-form-select formControlName="opportunity" [items]="opportunity"
                                            (isOpen)="fetchOpportunity()" [loading]="opportunityLoading"
                                            [isObject]="true" [optionDescription]="['code']">
                                        </apc-form-select>
                                    </div>

                                    <div class="form-group col-lg-4">
                                        <label>{{'order.offer' | translate}}</label>
                                        <apc-form-input [class]="'form-control'" formControlName="offer"
                                            [type]="'text'">
                                        </apc-form-input>
                                    </div>
                                </div>

                                <div class="row my-4">
                                    <div class="form-group col-lg-4">
                                        <label>{{'order.lob' | translate}}</label>
                                        <apc-form-select formControlName="lob" [items]="lob" (isOpen)="fetchLob()"
                                            [loading]="lobLoading" [isObject]="true" [optionDescription]="['code']">
                                        </apc-form-select>
                                    </div>

                                    <div class="form-group col-lg-4">
                                        <label>{{'order.pillar' | translate}}</label>
                                        <apc-form-select formControlName="pillar" [items]="pillar"
                                            (isOpen)="fetchPillar()" [loading]="lobLoading" [isObject]="true"
                                            [optionDescription]="['code']">
                                        </apc-form-select>
                                    </div>

                                    <div class="form-group col-lg-4">
                                        <label>{{'order.solution' | translate}}</label>
                                        <apc-form-select formControlName="solution" [items]="solution"
                                            (isOpen)="fetchSolution()" [loading]="solutionLoading" [isObject]="true"
                                            [optionDescription]="['code']">
                                        </apc-form-select>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- OWNERS -->

                <div class="apc-form-card">
                    <span class="title">{{'order.owners' | translate}}</span>
                    <div class="container-fluid my-2">
                        <div class="row my-4">
                            <div class="form-group col-lg-3">
                                <label>{{'order.ownerOrderManagement' | translate}}</label>
                                <apc-form-input [class]="'form-control'" formControlName="ownerOrderManagement"
                                    [type]="'text'">
                                </apc-form-input>
                            </div>
                            <div class="form-group col-lg-3">
                                <label>{{'order.ownerSales' | translate}}</label>
                                <apc-form-input [class]="'form-control'" formControlName="ownerSales" [type]="'text'">
                                </apc-form-input>
                            </div>

                            <div class="form-group col-lg-3">
                                <label>{{'order.ownerPresales' | translate}}</label>
                                <apc-form-input [class]="'form-control'" formControlName="ownerPresales"
                                    [type]="'text'">
                                </apc-form-input>
                            </div>
                            <div class="form-group col-lg-3">
                                <label>{{'order.ownerOperationsManager' | translate}}</label>
                                <apc-form-input [class]="'form-control'" formControlName="ownerOperationsManager"
                                    [type]="'text'">
                                </apc-form-input>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- OWNERS END-->

                <!-- INTEGRATION -->
                <div class="container-fluid">
                    <div class="row">
                        <div class="apc-form-card">
                            <span class="title">{{'order.integration' | translate}}</span>
                            <div class="container-fluid my-2">
                                <div class="row">
                                    <div class="form-group col-lg">
                                        <label>{{'order.owner' | translate}}</label>
                                        <apc-form-select formControlName="owner" [items]="owner" (isOpen)="fetchOwner()"
                                            [loading]="ownerLoading" [isObject]="true" [optionName]="'email'">
                                        </apc-form-select>
                                    </div>
                                    <div class="form-group col-lg">
                                        <label>{{'order.handler' | translate}}</label>
                                        <div ngbDropdown placement="bottom-left" [class.searchReadOnly]="!editForm">
                                            <div>
                                                <form autocomplete="off">
                                                    <input class="search-input form-control" type="text"
                                                        name="quick-search" id="quick-search"
                                                        [placeholder]="editForm ? 'Search handler' : ''"
                                                        [(ngModel)]="searchValue"
                                                        (ngModelChange)="isLoading=true; result=[]; form.controls.ownerHandler.reset(); this.quickSearch.next({ value: $event })">
                                                </form>
                                                <div *ngIf="isLoading && searchValue && searchValue.length > 0"
                                                    class="ng-spinner-loader"></div>
                                                <div ngbDropdownMenu aria-labelledby="quick-search"
                                                    [ngClass]="!userSelected && searchValue && searchValue.length > 0 ? 'show' : ''"
                                                    class="scrollable-menu" role="menu" placement="bottom-left"
                                                    style="width: max-content;">
                                                    <div ngbDropdownItem *ngFor="let res of result">
                                                        <div class="menu-button" (click)="selectUser(res)">
                                                            <div class="data-row"
                                                                [innerHTML]="constructDisplayName(res)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="result.length === 0 && !isLoading && !userSelected && !form.controls.ownerHandler.value"
                                                        ngbDropdownItem>
                                                        <div class="row menu-button">
                                                            {{'buttons.noResults' | translate}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <button class="btn closeSearch" (click)="closeSearch()">
                                                    <div [inlineSVG]="'assets/ico/clear-button.svg'"
                                                        class="icon icon-black clear-search-icon" alt="clear"></div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg">
                                        <label>{{'order.orderStatus' | translate}}</label>
                                        <apc-form-select formControlName="orderStatus" [items]="orderStatus"
                                            (isOpen)="fetchOrderStatus()" [loading]="orderStatusLoading"
                                            [isObject]="true">
                                        </apc-form-select>
                                    </div>
                                </div>
                                <div class="row my-4">
                                    <div class="form-group col-lg">
                                        <label>{{'order.tags' | translate}}</label>
                                        <tag-input [(ngModel)]="tags" [ngModelOptions]="{standalone: true}"
                                            [modelAsStrings]="true" [onAdding]="transform" (onAdd)="form.markAsDirty()"
                                            (onRemove)="form.markAsDirty()" [disable]="!editForm"
                                            [onlyFromAutocomplete]="false" [allowDupes]="false">
                                            <tag-input-dropdown [showDropdownIfEmpty]="false"
                                                [autocompleteObservable]="getTags">
                                            </tag-input-dropdown>
                                        </tag-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</apc-action-card>